(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  // Hash scroll functionality
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Filter toggle functionality for mobile
  document.addEventListener('DOMContentLoaded', () => {
    const filterToggle = document.querySelector('.filters-toggle-mobile');
    const filterClose = document.querySelector('.filters-sidebar__close');
    const filtersSidebar = document.querySelector('.filters-sidebar');

    // Create overlay element
    const overlay = document.createElement('div');
    overlay.className = 'filters-overlay';
    document.body.appendChild(overlay);

    if (filterToggle) {
      filterToggle.addEventListener('click', () => {
        filtersSidebar.classList.add('active');
        overlay.classList.add('active');
      });
    }

    if (filterClose) {
      filterClose.addEventListener('click', () => {
        filtersSidebar.classList.remove('active');
        overlay.classList.remove('active');
      });
    }

    overlay.addEventListener('click', () => {
      filtersSidebar.classList.remove('active');
      overlay.classList.remove('active');
    });

    // ── Sort select ──────────────────────────────────────────────────────────
    const sortSelect = document.getElementById('CollectionSortBy');
    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        const params = new URLSearchParams(window.location.search);
        params.set('sort_by', sortSelect.value);
        // Reset to page 1 when sort changes
        params.delete('page');
        window.location.search = params.toString();
      });
    }

    // ── Category (tag) filter checkboxes ────────────────────────────────────
    const categoryCheckboxes = document.querySelectorAll('.category-filter-checkbox');
    categoryCheckboxes.forEach(cb => {
      cb.addEventListener('change', () => {
        const filterType = cb.dataset.filterType || 'tag';
        const params = new URLSearchParams(window.location.search);
        params.delete('page');

        // Build base collection URL (strip any existing tag path segment)
        const pathParts = window.location.pathname.split('/').filter(Boolean);
        const collIdx = pathParts.indexOf('collections');
        const baseSegments = collIdx !== -1 ? pathParts.slice(0, collIdx + 2) : pathParts;
        const basePath = '/' + baseSegments.join('/');

        if (filterType === 'type') {
          // Product type filter: uses ?filter.p.product_type=Value
          params.delete('filter.p.product_type');
          const checked = Array.from(document.querySelectorAll('.category-filter-checkbox:checked'));
          checked.forEach(el => params.append('filter.p.product_type', el.value));
          window.location.href = basePath + (params.toString() ? '?' + params.toString() : '');
        } else {
          // Tag filter: uses /collections/handle/tag-slug
          const checked = Array.from(document.querySelectorAll('.category-filter-checkbox:checked'));
          if (checked.length > 0) {
            window.location.href = basePath + '/' + checked[0].value + (params.toString() ? '?' + params.toString() : '');
          } else {
            window.location.href = basePath + (params.toString() ? '?' + params.toString() : '');
          }
        }
      });
    });

    // Active-tag accordion toggle
    document.querySelectorAll('.filter-group__toggle').forEach(toggle => {
      toggle.addEventListener('click', () => {
        const group = toggle.closest('.filter-group');
        group.classList.toggle('is-collapsed');
        toggle.setAttribute('aria-expanded', !group.classList.contains('is-collapsed'));
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
